import React, { useEffect } from "react";
import withLayout from "../../layouts/withLayout";
import RelatedInfo from "@Components/common/RelatedInfo";

const Information = () => {
  useEffect(() => {}, []);

  return (
    <div className='pb-20'>
      <RelatedInfo title="" limit={20}/>
    </div>
  );
};

withLayout({
  cmp: <Information />,
  id: "summary-information",
  params: {
    webPageNav: false,
    footer: ""
  },
});
